﻿if (!customElements.get('tcg-card-controller')) {
  class TcgCardController extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('.tcg-card__variant-select');
      this.button = this.querySelector('[data-tcg-card-add-button]');
      this.addPrice = this.querySelector('[data-tcg-card-add-price]');
      this.addLabel = this.querySelector('[data-tcg-card-add-label]');
      this.form = this.querySelector('form');

      if (!this.select || !this.button) return;

      this.select.addEventListener('change', () => this.syncVariantState());
      this.syncVariantState();

      // Intercept form submission to show notification instead of redirect
      if (this.form) {
        this.form.addEventListener('submit', (e) => this.handleAddToCart(e));
      }
    }

    syncVariantState() {
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (!selectedOption) return;

      const variantPrice = selectedOption.dataset.variantPrice || '';
      const available = selectedOption.dataset.variantAvailable === 'true';

      if (this.addPrice) {
        this.addPrice.textContent = available && variantPrice ? variantPrice : '';
      }

      if (this.addLabel) {
        this.addLabel.textContent = available ? window.variantStrings?.addToCart || 'Add to cart' : 'Sold out';
      }

      this.button.disabled = !available;
    }

    getInventoryInfo() {
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (!selectedOption) return { tracksInventory: false, available: 0, cartQty: 0 };

      const tracksInventory = selectedOption.dataset.variantTracksInventory === 'true';
      const inventoryQty = parseInt(selectedOption.dataset.variantInventory) || 0;
      const cartQty = parseInt(selectedOption.dataset.variantCartQty) || 0;

      return {
        tracksInventory,
        available: inventoryQty,
        cartQty,
        remaining: inventoryQty - cartQty
      };
    }

    handleAddToCart(e) {
      e.preventDefault();

      // Check inventory before adding
      const inventory = this.getInventoryInfo();
      const quantityToAdd = 1;

      if (inventory.tracksInventory && inventory.remaining < quantityToAdd) {
        if (inventory.remaining <= 0) {
          this.showSuccessToast(null, 'Sorry, this item is out of stock!');
        } else {
          this.showSuccessToast(null, `Sorry, only ${inventory.remaining} left in stock!`);
        }
        return;
      }

      const originalLabel = this.addLabel?.textContent;
      this.button.disabled = true;
      if (this.addLabel) this.addLabel.textContent = 'Adding...';

      const formData = new FormData(this.form);
      const variantId = Number(formData.get('id'));
      const body = JSON.stringify({
        id: variantId,
        quantity: quantityToAdd,
      });

      fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body,
      })
        .then((res) => res.json())
        .then((response) => {
          // Check if Shopify returned an error (e.g., not enough stock)
          if (response.status === 422 || response.description || response.message) {
            const errorMsg = response.description || response.message || 'Could not add to cart';
            throw new Error(errorMsg);
          }

          this.showSuccessToast(response.title || response.product_title);
          this.updateCartBubble();
          this.updateLocalCartQty(variantId, quantityToAdd);
        })
        .catch((error) => {
          this.showSuccessToast(null, error.message || 'Could not add to cart. Please try again.');
        })
        .finally(() => {
          // Check if stock is now depleted after this add
          const updatedInventory = this.getInventoryInfo();
          if (updatedInventory.tracksInventory && updatedInventory.remaining <= 0) {
            this.button.disabled = true;
            if (this.addLabel) this.addLabel.textContent = 'Sold out';
            if (this.addPrice) this.addPrice.textContent = '';
          } else {
            this.button.disabled = false;
            if (this.addLabel) this.addLabel.textContent = originalLabel;
          }
        });
    }

    updateLocalCartQty(variantId, addedQty) {
      // Update the cart quantity data attribute so subsequent adds are checked correctly
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value == variantId) {
        const currentCartQty = parseInt(selectedOption.dataset.variantCartQty) || 0;
        selectedOption.dataset.variantCartQty = currentCartQty + addedQty;
      }
    }

    showSuccessToast(productTitle, errorMessage = null) {
      // Remove any existing toast
      const existing = document.querySelector('.tcg-cart-toast');
      if (existing) existing.remove();

      const toast = document.createElement('div');
      toast.className = 'tcg-cart-toast';

      if (productTitle) {
        toast.innerHTML =
          '<span class="tcg-cart-toast__icon">✓</span>' +
          '<span class="tcg-cart-toast__text">' +
          '<strong>' + productTitle + '</strong> added to cart!' +
          '</span>';
        toast.classList.add('tcg-cart-toast--success');
      } else {
        const message = errorMessage || 'Something went wrong. Please try again.';
        toast.innerHTML =
          '<span class="tcg-cart-toast__icon">✗</span>' +
          '<span class="tcg-cart-toast__text">' + message + '</span>';
        toast.classList.add('tcg-cart-toast--error');
      }

      document.body.appendChild(toast);

      // Trigger animation
      requestAnimationFrame(() => {
        toast.classList.add('tcg-cart-toast--visible');
      });

      // Auto-remove after 3 seconds
      setTimeout(() => {
        toast.classList.remove('tcg-cart-toast--visible');
        setTimeout(() => toast.remove(), 300);
      }, 3000);
    }

    updateCartBubble() {
      // Fetch updated cart count and update the header cart bubble
      fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => {
          const cartIcon = document.getElementById('cart-icon-bubble');
          if (!cartIcon) return;

          const bubble = cartIcon.querySelector('.cart-count-bubble');
          const emptyIcon = cartIcon.querySelector('.cart-icon-empty');
          const filledIcon = cartIcon.querySelector('.cart-icon-filled');

          if (cart.item_count > 0) {
            // Update the count
            if (bubble) {
              const countSpan = bubble.querySelector('[aria-hidden="true"]');
              if (countSpan) countSpan.textContent = cart.item_count;
              bubble.style.display = '';
            }

            // Switch to filled cart icon
            if (emptyIcon) emptyIcon.style.display = 'none';
            if (filledIcon) filledIcon.style.display = '';
          } else {
            // Hide bubble and show empty icon
            if (bubble) bubble.style.display = 'none';
            if (emptyIcon) emptyIcon.style.display = '';
            if (filledIcon) filledIcon.style.display = 'none';
          }
        })
        .catch(() => {});
    }
  }

  customElements.define('tcg-card-controller', TcgCardController);
}
